import Api from "./api";
import OidcManager from "./oidcManager";

export interface AreaCostsModifications {
    postalCode: string,
    checkEquipment: boolean,
    checkLabor: boolean,
    checkMaterial: boolean,
}


export class AreaCostsModificationsApi extends Api {

    public constructor(oidc: OidcManager, address: string) {
        super(oidc, address)
    }

    load(command: {estimateId: number }): JQueryPromise<AreaCostsModifications> {
        return super.get("/api/area-costs-modifications", command);
    }

    save(command: AreaCostsModifications & { estimateId: number }): JQueryPromise<AreaCostsModifications> {
        return super.post("/api/area-costs-modifications", command);
    }
}


// WEBPACK FOOTER //
// ./ClientApp/services/api/area-costs-modifications.ts